import React from "react";
import { Button, Text } from "@mantine/core";
import styles from "./DashBoardNotificationBox.module.css";
import { formatDate, formatTime } from "../../utilities/utilities";

const BRAND = "#46BDE1";

function DashBoardNotificationBox({
  backgroundColor,
  date,
  module,
  notificationText,
  btnName,
  onBtnClick,
  isDeleted,
  seen,
}) {
  const dateLabel = `${formatDate(date)} · ${formatTime(date)}`;

  return (
    <article
      className={`${styles.card} ${seen ? "" : styles.unread} mt-1`}
      style={{ "--accent-color": backgroundColor || BRAND }}
    >
      <span className={styles.module}>{module}</span>
      <Text className={styles.message} lineClamp={2} title={notificationText}>
        {notificationText}
      </Text>
      <Text className={styles.date}>{dateLabel}</Text>
      {btnName ? (
        <Button
          disabled={isDeleted || !onBtnClick}
          onClick={onBtnClick}
          compact
          size="xs"
          radius="sm"
          className={styles.btn}
          styles={{
            root: {
              backgroundColor: isDeleted ? "#e2e8f0" : BRAND,
              color: isDeleted ? "#64748b" : "#fff",
              height: 28,
              padding: "0 10px",
              fontSize: 12,
              fontWeight: 600,
            },
          }}
        >
          {isDeleted ? "N/A" : btnName}
        </Button>
      ) : null}
    </article>
  );
}

export default DashBoardNotificationBox;
